﻿$.fn.dxCtrlNumberBox = function custom_dxCtrlNumberBox(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlnumberbox dx-ctrl");
        this.createInstance(new cdxCtrlNumberBox(this, option));
    }
    return this;
}

window.cdxCtrlNumberBox = function (container, option) {
    var Me = this;
    if (typeof option.value == 'undefined') option.value = null;
    if (typeof option.isFloat == 'undefined') option.isFloat = false;
    if (typeof option.noNull == 'undefined') option.noNull = true;
    if (typeof option.tempoOnValueChanged == 'undefined') option.tempoOnValueChanged = 1000;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return dx.option(name);
        }
        else {
            dx.option(name, value);
            if (name == "visible") {
                if (value) { $TdUniteMesure.show() } else { $TdUniteMesure.hide() }
            }
        }
    }

    var dx = null;
    var dxExposant = null;
    var $TdUniteMesure = null;
    var $DivBtPad = null
    function mConstruit() {
        container.empty();
        if (typeof option.obligatoire != 'undefined' && option.obligatoire) container.addClass("saisie_obligatoire")
        var $Table = $("<table style='width:100%'/>").appendTo(container);

        var valExposant = 0
        if (option.value == null && option.noNull) option.value = ((typeof option.min != 'undefined') ? option.min : 0);
        //if (option.avecExposant) {
        //    option.isFloat = false
        //    option.value = Math.floor(option.value)
        //    if (option.value != null && option.value.toString().endsWith("000")) {
        //        var num = option.value.toString();
        //        for (var i = num.length - 1; i >= 0; i--) {
        //            if (num[i] == "0") { valExposant += 1; } else { break; }
        //            if (valExposant == 12) break;
        //        }
        //        var newValue = ""
        //        for (var i = 0; i < num.length - valExposant; i++) {
        //            newValue += num[i];
        //        }
        //        option.value = newValue
        //    }
        //}
        if (option.value != null) {
            if (option.isFloat) { option.value = parseFloat(option.value); }
            else { option.value = parseInt(option.value); }
        }

        var timeOutOnValueChanged = null;
        var onvaluechanged = option.onValueChanged
        option.onValueChanged = function (e) {
            if (option.desactiveTimeout) {
                onvaluechanged(e)
            } else {
                option.value = e.value
                console.log("onValueChanged " + option.value)
                window.clearTimeout(timeOutOnValueChanged)
                timeOutOnValueChanged = window.setTimeout(function () {
                    if (typeof onvaluechanged != 'undefined') onvaluechanged(e)
                    timeOutOnValueChanged = null
                }, 500)
            }

        }

        var onfocusout = option.onFocusOut
        option.onFocusOut = function (e) {
            if (timeOutOnValueChanged != null) {
                window.clearTimeout(timeOutOnValueChanged)
                if (typeof onvaluechanged != 'undefined') onvaluechanged({ value: option.value, component: dx })
            }
            console.log("onFocusOut")
            //if (e.component.option("value") == null && option.noNull) { dx.option("value", ((typeof option.min != 'undefined') ? option.min : 0)) }
            //if (dxExposant) e.component.option("value", e.component.option("value") * Math.pow(10, ((dxExposant.option("value") == null) ? 0 : dxExposant.option("value"))))

            const val = e.component.option("value");

            if ((val == null || isNaN(val)) && option.noNull) {
                const fallback = (e.previousValue != null && !isNaN(e.previousValue))
                    ? e.previousValue                                   // on restaure l'ancienne valeur
                    : (typeof option.min != 'undefined' ? option.min : 0); // sinon min/0, comme avant

                e.component.option("value", fallback);
            }

            if (typeof onfocusout != 'undefined') onfocusout(e)
        }

        if (option.buttonLeftRight) {
            option.buttons = [{
                focusStateEnabled: false,
                name: 'pre',
                location: 'before',
                options: {
                    icon: 'spinprev',
                    stylingMode: 'text',
                    onClick() {
                        if (typeof option.min == 'undefined' || (typeof option.min != 'undefined' && dx.option("value") > option.min)) {
                            dx.option("value", dx.option("value") - 1)
                        }
                    },
                },
            }, {
                focusStateEnabled: false,
                name: 'next',
                location: 'after',
                options: {
                    icon: 'spinnext',
                    stylingMode: 'text',
                    onClick() {
                        if (typeof option.max == 'undefined' || (typeof option.max != 'undefined' && dx.option("value") < option.max)) {
                            dx.option("value", dx.option("value") + 1)
                        }
                    },
                },
            }]
        }

        if (parametre.isMobile && !option.hidePadNum) {
            if (!option.inputAttr) option.inputAttr = {}
            option.inputAttr.inputmode = 'none'
        }


        var $Tr = $("<tr/>").appendTo($Table);
        var $Td = $("<td style='width:100%'/>").appendTo($Tr);
        dx = $("<div/>").appendTo($Td).dxNumberBox(option).dxNumberBox("instance");
        //if (option.avecExposant) {
        //    var $Td = $("<td style='width:1px' class='dx-field-item-label-text'>x10<sup>^</sup></td>").appendTo($Tr);
        //    var $Td = $("<td style='width:80px;min-width:80px'></td>").appendTo($Tr);
        //    dxExposant = $("<div/>").appendTo($Td).dxNumberBox({
        //        min: 0,
        //        max: 12,
        //        showSpinButtons: true,
        //        value: valExposant,
        //        onValueChanged: function (e) {
        //            if (!e.value && option.noNull) { e.component.option("value", ((typeof option.min != 'undefined') ? option.min : 0)) }
        //            e.value = dx.option("value")
        //            option.onValueChanged(e)
        //        }
        //    }).dxNumberBox("instance")
        //}
        $TdUniteMesure = $("<td style='" + ((typeof option.width_unite_mesure != 'undefined') ? "min-width:" + option.width_unite_mesure + "px;" : "width:1px;") + "text-align:left;white-space:nowrap;padding-left:5px;vertical-align:bottom;padding-bottom:7px;" + ((typeof option.unite_mesure == 'undefined' || (typeof option.visible != 'undefined' && !option.visible)) ? "display:none;" : "") + "' class='dx-field-item-label-text'>" + ((typeof option.unite_mesure == 'undefined') ? "" : option.unite_mesure) + "</td>").appendTo($Tr);
        dx.element().find("input").css("text-align", ((typeof option.textAlign != 'undefined') ? option.textAlign : "right"))

        $DivBtPad = $("<div style='width:100%'/>").appendTo(container)

        if (typeof option.readOnly == 'undefined' || option.readOnly) {
            //dx.option("readOnly", parametre.isMobile);
            dx.option("readOnly", false);
        }
        dx.option("onFocusIn", function (e) {
            //if (dx.option("readOnly")) mShowToolTipCalculatrice(dx, false);
            if (typeof option.onFocusIn != 'undefined') option.onFocusIn(e);
            dx.element().find("input").select();
            if (parametre.isMobile && !option.hidePadNum) mShowToolTipCalculatrice()
        })
        if (!option.isFloat) {
            dx.option("onKeyDown", function (e) {
                var event = e.event;
                //var str = String.fromCharCode(event.keyCode);
                var str = event.key;
                if (typeof str != 'undefined' && str.length == 1 && !/[0-9]/.test(str) && str != '-') {
                    event.preventDefault();
                } else {
                    if (typeof option.onKeyDown != 'undefined') option.onKeyDown(e);
                }
            });
            dx.option("showSpinButtons", ((typeof option.showSpinButtons == "undefined") ? true : option.showSpinButtons));
        } else {
            dx.option("onKeyDown", function (e) {
                if (typeof option.onKeyDown != 'undefined') option.onKeyDown(e);
            });
        }

        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
            container.attr("title", option.txtTooltip.remplacerTout("<br/>", "%cr%"))
            //tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
        }

        if (parametre.isMobile) dx.option("showSpinButtons", ((typeof option.showSpinButtons == "undefined") ? false : option.showSpinButtons));
    }

    //function mConstruitTabNum() {
    //    $DivBtPad.empty()
    //    $DivBtPad.hide()
    //    var currentValue = dx.option("value")
    //    currentValue = (currentValue === null || currentValue === undefined) ? "" : currentValue.toString();
    //    var $Table = $("<table style='width:100%;'/>").appendTo($DivBtPad)
    //    var $Tr = $("<tr/>").appendTo($Table)
    //    var dsNb = [7, 8, 9]
    //    dsNb.forEach(function (i) {
    //        $Td = $("<td/>").appendTo($Tr)
    //        $("<div style='padding:2px;width:100%;'/>").appendTo($Td).dxCtrlButton({
    //            text: i,
    //            width: "100%",
    //            onClick: function (e) {
    //                appendDigit(i.toString())
    //            }
    //        }).dxCtrlButton("instance");
    //    })
    //    var dsNb = [4, 5, 6]
    //    var $Tr = $("<tr/>").appendTo($Table)
    //    dsNb.forEach(function (i) {
    //        $Td = $("<td/>").appendTo($Tr)
    //        $("<div style='padding:2px;width:100%;'/>").appendTo($Td).dxCtrlButton({
    //            text: i,
    //            width: "100%",
    //            onClick: function (e) {
    //                appendDigit(i.toString())
    //            }
    //        }).dxCtrlButton("instance");
    //    })
    //    var dsNb = [1, 2, 3]
    //    var $Tr = $("<tr/>").appendTo($Table)
    //    dsNb.forEach(function (i) {
    //        $Td = $("<td/>").appendTo($Tr)
    //        $("<div style='padding:2px;width:100%;'/>").appendTo($Td).dxCtrlButton({
    //            text: i,
    //            width: "100%",
    //            onClick: function (e) {
    //                appendDigit(i.toString())
    //            }
    //        }).dxCtrlButton("instance");
    //    })

    //    var btPoint = null
    //    var dsNb = ["0", ",", "x"]
    //    if (!option.isFloat) dsNb = ["0", "x"]
    //    var $Tr = $("<tr/>").appendTo($Table)
    //    dsNb.forEach(function (i) {
    //        $Td = $("<td/>").appendTo($Tr)
    //        if (!option.isFloat && i == "0") $Td.attr("colspan", "2")
    //        switch (i) {
    //            case "":
    //                break;
    //            case "x":
    //                $("<div style='padding:2px;width:100%;'/>").appendTo($Td).dxCtrlButton({
    //                    text: "♻",
    //                    width: "100%",
    //                    txtTooltip: "Effacer tout",
    //                    onClick: function (e) {
    //                        clearValue()
    //                    }
    //                }).dxCtrlButton("instance");
    //                break;
    //            case ",":
    //            default:
    //                btPoint = $("<div style='width:100%;padding:2px;'/>").appendTo($Td).dxCtrlButton({
    //                    text: i,
    //                    disabled: ((i == ",") ? currentValue.contains(".") : false),
    //                    width: "100%",
    //                    onClick: function (e) {
    //                        appendDot()
    //                    }
    //                }).dxCtrlButton("instance");
    //                break;
    //        }

    //    })
    //    updateCommaButtonState();

    //    $DivBtPad.slideDown(100)

    //    // Chiffres 0-9 : même fonction pour tous
    //    function appendDigit(digit) {
    //        var maxDecimals = getDecimalDigits();

    //        if (currentValue.indexOf(".") !== -1 && maxDecimals !== null) {
    //            var decimalPart = currentValue.split(".")[1];
    //            if (decimalPart.length >= maxDecimals) {
    //                return; // limite de décimales atteinte, on ignore la saisie
    //            }
    //        }

    //        currentValue += digit;
    //        dx.option("value", parseFloat(currentValue));
    //        updateCommaButtonState();
    //    }

    //    // Bouton "."
    //    function appendDot() {
    //        var maxDecimals = getDecimalDigits();
    //        if (maxDecimals === 0) return; // format n'autorise aucune décimale

    //        if (currentValue.indexOf(".") === -1) {
    //            currentValue += (currentValue === "" ? "0." : ".");
    //            dx.option("value", parseFloat(currentValue));
    //            updateCommaButtonState();
    //        }
    //    }

    //    // Bouton "Clear"
    //    function clearValue() {
    //        currentValue = "";
    //        dx.option("value", null);
    //        updateCommaButtonState();
    //    }

    //    function updateCommaButtonState() {
    //        var maxDecimals = getDecimalDigits();
    //        var hasDot = currentValue.indexOf(".") !== -1;

    //        btPoint.option("disabled", hasDot || maxDecimals === 0);
    //    }
    //}

    function getDecimalDigits() {
        var format = dx.option("format");
        if (!format) return null; // pas de format => pas de limite

        // format sous forme de chaîne : "0.000", "#,##0.00", etc.
        if (typeof format === "string") {
            var match = format.match(/\.([0#]+)/);
            return match ? match[1].length : 0;
        }

        // format sous forme d'objet : { type: "fixedPoint", precision: 3 }
        if (typeof format === "object" && format.precision !== undefined) {
            return format.precision;
        }

        return null;
    }
    var ttCalc = null
    function mShowToolTipCalculatrice(dxNumBerBox) {
        var hbt = 54
        var paddingleftRight = 30
        ttCalc = $("<div/>").appendTo("body").dxCtrlTooltip({
            target: dx.element(),
            width: (hbt * 3 + paddingleftRight * 2 + 10),
            position: ((typeof position == 'undefined' || !position) ? "bottom" : position),
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "10px " + paddingleftRight + "px")
                var $Table = $("<table/>").appendTo(contentElement)
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "7",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("7") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "8",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("8") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "9",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("9") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "4",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("4") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "5",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("5") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "6",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("6") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "1",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("1") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "2",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("2") }
                })
                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "3",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("3") }
                })
                var $Tr = $("<tr/>").appendTo($Table)
                var $Td = $("<td colspan='1'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "0",
                    width: hbt,
                    height: hbt,
                    onClick: function (e) { mAddChiffre("0") }
                })
                if (option.isFloat) {
                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        text: ".",
                        width: hbt,
                        height: hbt,
                        onClick: function (e) {
                            //var value = dx.option("value")
                            //if (!value) value = "";
                            //value = value.toString();
                            if (!currentValue.contains(".")) mAddChiffre(".")
                        }
                    })
                }
                var $Td = $("<td colspan='" + (option.isFloat ? "1" : "2") + "'/>").appendTo($Tr)
                $("<div/>").appendTo($Td).dxCtrlButton({
                    text: "♺",
                    width: (option.isFloat ? hbt : "100%"),
                    height: hbt,
                    onClick: function (e) {
                        currentValue = ""
                        dx.option("value", (typeof option.default != 'undefined' ? option.default : 0))
                    }
                })
                //var $Td = $("<td colspan='2'/>").appendTo($Tr)
                //$("<div/>").appendTo($Td).dxCtrlButton({
                //    text: "⇦",
                //    width: "100%",
                //    height: hbt,
                //    onClick: function (e) {
                //        var value = dx.option("value")
                //        if (!value) value = "";
                //        value = value.toString();
                //        if (value.length > 0) {
                //            dx.option("value", value.substring(0, value.length - 1))
                //        }
                //    }
                //})
            },
            onHiding: function () { ttCalc = null }
        }).dxCtrlTooltip("instance");
        ttCalc.show();

        var currentValue = ""
        function mAddChiffre(chiffre) {
            //var value = dx.option("value")
            //if (!value) value = "";
            //value = value.toString();
            var maxDecimals = getDecimalDigits();
            if (maxDecimals != null && currentValue.contains(".") && currentValue.split(".")[1].length >= maxDecimals) return
            currentValue += chiffre;
            dx.option("value", currentValue)
        }
    }

    this.component = function () { return dx; }
    this.focus = function () { dx.focus(); }
    this.element = function () { return container; }

    mConstruit();
}


















//$.fn.dxCtrlNumberBox = function custom_dxCtrlNumberBox(option) {
//    if (option == "instance") {
//        return this.instance;
//    }
//    else {
//        this.addClass("dx-ctrlnumberbox dx-ctrl");
//        this.createInstance(new cdxCtrlNumberBox(this, option));
//    }
//    return this;
//}

//function cdxCtrlNumberBox(container, option) {
//    var Me = this;
//    if (typeof option.value == 'undefined') option.value = null;
//    if (typeof option.isFloat == 'undefined') option.isFloat = false;
//    if (typeof option.noNull == 'undefined') option.noNull = true;
//    if (typeof option.tempoOnValueChanged == 'undefined') option.tempoOnValueChanged = 1000;

//    this.option = function (name, value) {
//        if (typeof value == 'undefined') {
//            return dx.option(name);
//        }
//        else {
//            var save = option.declencheOnValueChangedDirect
//            option.declencheOnValueChangedDirect = true
//            dx.option(name, value);
//            if (name == "visible") {
//                if (value) { $TdUniteMesure.show() } else { $TdUniteMesure.hide() }
//            }
//            option.declencheOnValueChangedDirect = save
//        }
//    }

//    var dx = null;
//    var dxExposant = null;
//    var $TdUniteMesure = null;
//    function mConstruit() {
//        container.empty();
//        var $Table = $("<table style='width:100%'/>").appendTo(container);

//        var valExposant = 0
//        if (option.value == null && option.noNull) option.value = ((typeof option.min != 'undefined') ? option.min : 0);
//        if (option.avecExposant) {
//            option.isFloat = false
//            option.value = Math.floor(option.value)
//            if (option.value != null && option.value.toString().endsWith("000")) {
//                var num = option.value.toString();
//                for (var i = num.length - 1; i >= 0; i--) {
//                    if (num[i] == "0") { valExposant += 1; } else { break; }
//                    if (valExposant == 12) break;
//                }
//                var newValue = ""
//                for (var i = 0; i < num.length - valExposant; i++) {
//                    newValue += num[i];
//                }
//                option.value = newValue
//            }
//        }
//        if (option.value != null) {
//            if (option.isFloat) { option.value = parseFloat(option.value); }
//            else { option.value = parseInt(option.value); }
//        }

//        var timeOutOnValueChanged = null;
//        var inOnValueChanged = false

//        var valueChanged = false
//        var onvaluechanged = option.onValueChanged
//        var valueOnValueChanged = option.value
//        option.onValueChanged = function (e) {
//            valueChanged = true
//            valueOnValueChanged = e.value
//            if (option.declencheOnValueChangedDirect || e.declencheOnValueChangedDirect) option.onFocusOut(e)
//        }
//        if (!((typeof option.showSpinButtons == "undefined") ? false : option.showSpinButtons)) {
//            option.declencheOnValueChangedDirect = true
//        }

//        var onfocusout = option.onFocusOut
//        option.onFocusOut = function (e) {
//            if (inOnValueChanged) return
//            inOnValueChanged = true
//            if (valueChanged) {
//                if (!valueOnValueChanged && option.noNull) { dx.option("value", ((typeof option.min != 'undefined') ? option.min : 0)) }
//                if (dxExposant) valueOnValueChanged = valueOnValueChanged * Math.pow(10, ((dxExposant.option("value") == null) ? 0 : dxExposant.option("value")))
//                if (typeof onvaluechanged != 'undefined') {
//                    e.value = valueOnValueChanged
//                    onvaluechanged(e)
//                    //if (typeof option.tempoOnValueChanged == 'undefined') { onvaluechanged(e) }
//                    //else {
//                    //    window.clearTimeout(timeOutOnValueChanged)
//                    //    timeOutOnValueChanged = window.setTimeout(function () { onvaluechanged(e) }, option.tempoOnValueChanged)
//                    //}
//                }
//                valueChanged = false
//            }
//            inOnValueChanged = false
//            if (typeof onfocusout != 'undefined') onfocusout(e)
//        }
//        //var onvaluechanged = option.onValueChanged
//        //option.onValueChanged = function (e) {
//        //}

//        var $Tr = $("<tr/>").appendTo($Table);
//        var $Td = $("<td style='width:100%'/>").appendTo($Tr);
//        dx = $("<div/>").appendTo($Td).dxNumberBox(option).dxNumberBox("instance");
//        if (option.avecExposant) {
//            var $Td = $("<td style='width:1px' class='dx-field-item-label-text'>x10<sup>^</sup></td>").appendTo($Tr);
//            var $Td = $("<td style='width:50px;min-width:50px'></td>").appendTo($Tr);
//            dxExposant = $("<div/>").appendTo($Td).dxNumberBox({
//                min: 0,
//                max: 12,
//                showSpinButtons: true,
//                value: valExposant,
//                onValueChanged: function (e) {
//                    if (!e.value && option.noNull) { e.component.option("value", ((typeof option.min != 'undefined') ? option.min : 0)) }
//                    e.value = dx.option("value")
//                    option.onValueChanged(e)
//                }
//            }).dxNumberBox("instance")
//        }
//        $TdUniteMesure = $("<td style='width:1px;white-space:nowrap;padding-left:5px;vertical-align:bottom;padding-bottom:7px;" + ((typeof option.unite_mesure == 'undefined' || (typeof option.visible != 'undefined' && !option.visible)) ? "display:none;" : "") + "' class='dx-field-item-label-text'>" + ((typeof option.unite_mesure == 'undefined') ? "" : option.unite_mesure) + "</td>").appendTo($Tr);
//        dx.element().find("input").css("text-align", "right")

//        if (typeof option.readOnly == 'undefined' || option.readOnly) {
//            dx.option("readOnly", parametre.isMobile);
//        }
//        dx.option("onFocusIn", function (e) {
//            if (dx.option("readOnly")) mShowToolTipCalculatrice(dx, false);
//            if (typeof option.onFocusIn != 'undefined') option.onFocusIn(e);
//            dx.element().find("input").select();
//        })
//        if (!option.isFloat) {
//            dx.option("onKeyDown", function (e) {
//                var event = e.event;
//                //var str = String.fromCharCode(event.keyCode);
//                var str = event.key;
//                if (str.length == 1 && !/[0-9]/.test(str)) {
//                    event.preventDefault();
//                } else {
//                    if (typeof option.onKeyDown != 'undefined') option.onKeyDown(e);
//                }
//            });
//            dx.option("showSpinButtons", ((typeof option.showSpinButtons == "undefined") ? true : option.showSpinButtons));
//        } else {
//            dx.option("onKeyDown", function (e) {
//                if (typeof option.onKeyDown != 'undefined') option.onKeyDown(e);
//            });
//        }

//        if (typeof option.txtTooltip != 'undefined' && option.txtTooltip.length > 0) {
//            tt = $("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: container, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;'>" + option.txtTooltip + "</div>").appendTo(contentElement); } }).dxCtrlTooltipHoverTarget("instance");
//        }

//        if (parametre.isMobile) dx.option("showSpinButtons", ((typeof option.showSpinButtons == "undefined") ? false : option.showSpinButtons));
//    }

//    function mShowToolTipCalculatrice(dxNumBerBox) {
//        tt = $("<div/>").appendTo("body").dxCtrlTooltip({
//            target: dxNumBerBox.element(),
//            width: 230,
//            position: ((typeof position == 'undefined' || !position) ? "bottom" : position),
//            contentTemplate: function (contentElement) {
//                var $Table = $("<table/>").appendTo(contentElement)
//                var $Tr = $("<tr/>").appendTo($Table)
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "7",
//                    onClick: function (e) { mAddChiffre("7") }
//                })
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "8",
//                    onClick: function (e) { mAddChiffre("8") }
//                })
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "9",
//                    onClick: function (e) { mAddChiffre("9") }
//                })
//                var $Tr = $("<tr/>").appendTo($Table)
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "4",
//                    onClick: function (e) { mAddChiffre("4") }
//                })
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "5",
//                    onClick: function (e) { mAddChiffre("5") }
//                })
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "6",
//                    onClick: function (e) { mAddChiffre("6") }
//                })
//                var $Tr = $("<tr/>").appendTo($Table)
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "1",
//                    onClick: function (e) { mAddChiffre("1") }
//                })
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "2",
//                    onClick: function (e) { mAddChiffre("2") }
//                })
//                var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "3",
//                    onClick: function (e) { mAddChiffre("3") }
//                })
//                var $Tr = $("<tr/>").appendTo($Table)
//                var $Td = $("<td colspan=" + ((option.isFloat) ? "2" : '3') + "/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    text: "0",
//                    width: "100%",
//                    onClick: function (e) { mAddChiffre("0") }
//                })
//                if (option.isFloat) {
//                    var $Td = $("<td style='width:1px'/>").appendTo($Tr)
//                    $("<div/>").appendTo($Td).dxCtrlButton({
//                        text: ".",
//                        onClick: function (e) {
//                            var value = dxNumBerBox.option("value")
//                            if (!value) value = "";
//                            value = value.toString();
//                            if (!value.contains(".")) mAddChiffre(".")
//                        }
//                    })
//                }
//                var $Tr = $("<tr/>").appendTo($Table)
//                var $Td = $("<td colspan='1'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    icon: "fas fa-trash-alt",
//                    width: "100%",
//                    onClick: function (e) { dxNumBerBox.option("value", null) }
//                })
//                var $Td = $("<td colspan='2'/>").appendTo($Tr)
//                $("<div/>").appendTo($Td).dxCtrlButton({
//                    icon: "fas fa-long-arrow-alt-left",
//                    width: "100%",
//                    onClick: function (e) {
//                        var value = dxNumBerBox.option("value")
//                        if (!value) value = "";
//                        value = value.toString();
//                        if (value.length > 0) {
//                            dxNumBerBox.option("value", value.substring(0, value.length - 1))
//                        }
//                    }
//                })
//            }
//        }).dxCtrlTooltip("instance");
//        tt.show();

//        function mAddChiffre(chiffre) {
//            var value = dxNumBerBox.option("value")
//            if (!value) value = "";
//            value = value.toString();
//            value += chiffre;
//            dxNumBerBox.option("value", value)
//        }
//    }

//    this.component = function () { return dx; }
//    this.focus = function () { dx.focus(); }
//    this.element = function () { return container; }

//    mConstruit();
//}